import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import AnimatedRouter from 'components/AnimatedRouter';
import Card from 'components/Card';
import security from 'stores/security';
import Add from './modules/Add';
import AuthLayout from './modules/Auth';
import AuthComplete from './modules/Auth/Complete';
import AuthManual from './modules/Auth/Manual';
import AuthSelectWay from './modules/Auth/SelectWay';
import Edit from './modules/Edit';
import './style.scss';

const Bankcards: React.FC = () => {
    const render = () => {
        if (security.isMarscoAuditing) {
            return (
                <AnimatedRouter component={null} timeout={300}>
                    <Route path="auth" element={<AuthLayout />}>
                        <Route path="select-way" element={<AuthSelectWay />} />
                        <Route path="*" element={<Navigate to="./select-way" replace />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/profile" replace />} />
                </AnimatedRouter>
            );
        }

        return (
            <AnimatedRouter component={null} timeout={300}>
                <Route path="add" element={<Add />} />
                <Route path="edit/:id" element={<Edit />} />
                <Route path="auth" element={<AuthLayout />}>
                    <Route path="select-way" element={<AuthSelectWay />} />
                    <Route path="manual" element={<AuthManual />} />
                    <Route path="complete" element={<AuthComplete />} />
                    <Route path="*" element={<Navigate to="./select-way" replace />} />
                </Route>
                {/**
                 * 因暂时不展示银行卡模块，因此未匹配到路由暂时重定向到首页
                 */}
                <Route path="*" element={<Navigate to="/profile" replace />} />
            </AnimatedRouter>
        );
    };

    return (
        <Card page>
            <div className="bankcards-root">{render()}</div>
        </Card>
    );
};

export default Bankcards;
